module.exports = __webpack_public_path__ + "static/media/cw.8b8e7d53.svg";